<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-print`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31.23 4a2 2 0 011.426.598l2.77 2.818A2 2 0 0136 8.818V14h7a2 2 0 012 2v18a2 2 0 01-2 2h-7v6a2 2 0 01-2 2H14a2 2 0 01-2-2v-6H5a2 2 0 01-2-2V16a2 2 0 012-2h7V6a2 2 0 012-2h17.23zM32 33H16v7h16v-7zm9-15H7v14h5v-1a2 2 0 012-2h20a2 2 0 012 2v1h5V18zm-5 4v4h-4v-4h4zM29 7.999L16 8v6h16v-3h-3V7.999z"/></svg>
</template>
<script>

export default {
  name: 'IconPrint',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
